// extracted by mini-css-extract-plugin
export default {"details":"IxrxO34QHcpyK45GCcTb","caret":"FIEEj_c0POqEsmYg4ayr","safariFix":"zu_GkLKX07A72KLTimID","list":"VRGfDyDIAkoXnwNdkdQ2"};